import './PropertyGroupList.scss';
import Component from './PropertyGroupList.js';
export default Component;
